import * as React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Dashboard from './Dashboard';
import Signin from './SignIn';
import Orders from './Orders';
import OrdersReport from './OrdersReport';
import DailySalesReport from './DailySalesReport';
import RidersMap from './Components/RirdersMap/RidersMap';
import Customers from './Customer';
import Chefs from './Chefs';
import Reports from './Reports';
import ChefOrders from './Components/ChefOrders/ChefOrders';
import EditUser from './Components/EditUser/Edit-User';
import Dishes from './Dishes';
import Registrations from './Components/Registrations/registrations';
import RegistrationDetails from './Components/registration-details/registration-details';
import Gifts from './Components/gifts/gifts';
import Drivers from './Components/DriversRegistration/Drivers';
import AddProduct from './Components/AddGiftProducts/AddGiftProducts'
import GiftOrders from './Components/GiftOrders/GiftOrder'
import GiftOrderDetails from './Components/GiftOrderDetails/GiftOrderDetails';
import OrderDetails from './Components/OrderDetails/order-details';
import Forgot from './Components/forgot-password/forgot-password';
import Employees from './Components/Employees/Employees';
import AddEmployee from './Components/AddEmployee/AddEmployee';
import EditGift from './Components/edit-gifts/edit-gifts'
import Bookings from './Components/Iftar-booking/iftar-booking';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Signin />} />
        <Route exact path="/forgot" element={<Forgot />} />
        <Route exact
          path="/dashboard"
          element={<Dashboard />}
          children={<Route path='' element={<Reports />}></Route>
          } />
        <Route exact
          path="/orders"
          element={<Dashboard />}
          children={<Route path='' element={<Orders />}>
          </Route>
          } />
        <Route exact
          path="/ordersreport"
          element={<Dashboard />}
          children={<Route path='' element={<OrdersReport/>}>
          </Route>
          } />
          <Route exact
          path="/dailysalesreport"
          element={<Dashboard />}
          children={<Route path='' element={<DailySalesReport/>}>
          </Route>
          } />
          
        <Route exact
          path="/ridersmap"
          element={<Dashboard />}
          children={<Route path='' element={<RidersMap/>}>
          </Route>
          } />

        <Route exact
          path="/gift/orders"
          element={<Dashboard />}
          children={<Route path='' element={<GiftOrders />}>
          </Route>
          } />
        <Route exact
          path="/customers"
          element={<Dashboard />}
          children={<Route path='' element={<Customers />}>
          </Route>
          } />
        <Route exact
          path="/chefs"
          element={<Dashboard />}
          children={<Route path='' element={<Chefs />}>
          </Route>
          } />
        <Route exact
          path="/dishes"
          element={<Dashboard />}
          children={<Route path='' element={<Dishes />}>
          </Route>
          } />
        <Route exact
          path="/orders/chef/:id"
          element={<Dashboard />}
          children={<Route path='' element={<ChefOrders />}>
          </Route>
          } />
        <Route exact
          path="/user/edit/:id"
          element={<Dashboard />}
          children={<Route path='' element={<EditUser />}>
          </Route>
          } />
        <Route exact
          path="/registrations"
          element={<Dashboard />}
          children={<Route path='' element={<Registrations />}>
          </Route>
          } />
        <Route exact
          path="/details/:id"
          element={<Dashboard />}
          children={<Route path='' element={<RegistrationDetails />}>
          </Route>
          } />
        <Route exact
          path="/gifts"
          element={<Dashboard />}
          children={<Route path='' element={<Gifts />}>
          </Route>
          } />
        <Route exact
          path="/drivers"
          element={<Dashboard />}
          children={<Route path='' element={<Drivers />}>
          </Route>
          } />
        <Route exact
          path="/add/product"
          element={<Dashboard />}
          children={<Route path='' element={<AddProduct />}>
          </Route>
          } />
        <Route exact
          path="/edit/product/:id"
          element={<Dashboard />}
          children={<Route path='' element={<EditGift />}>
          </Route>
          } />
        <Route exact
          path="/gift/order/:id"
          element={<Dashboard />}
          children={<Route path='' element={<GiftOrderDetails />}>
          </Route>
          } />
        <Route exact
          path="/order/:id"
          element={<Dashboard />}
          children={<Route path='' element={<OrderDetails />}>
          </Route>
          } />
        <Route exact
          path="/bookings"
          element={<Dashboard />}
          children={<Route path='' element={<Bookings />}>
          </Route>
          } />
        <Route
          exact
          path="/employees/:id"
          element={<Dashboard />}
          children={<Route path='' element={<OrderDetails />}>
          </Route>
          } />
        <Route exact
          path="/employees/add"
          element={<Dashboard />}
          children={<Route path='' element={<AddEmployee />}>
          </Route>
          } />
      </Routes>
    </Router>
  );
}